var HaikuDOMAdapter = require('@haiku/core/dom')
module.exports = HaikuDOMAdapter(require('./code'))


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon6/code/main/dom.js
// module id = 460
// module chunks = 127651196306611